var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8079 30.896C43.8537 30.3417 45.391 29.777 47.65 29.3377V20.2914C47.65 20.2914 45.0145 20.0822 42.8601 18.9004C41.9712 18.4089 41.5424 17.3631 41.8352 16.3905C42.1804 15.261 42.8601 13.7759 44.157 11.883L37.7566 5.48258C37.7566 5.48258 35.6963 7.23955 33.3014 7.90888C32.3601 8.17033 31.3561 7.71017 30.896 6.84214C30.3417 5.79632 29.777 4.25897 29.3377 2H20.2914C20.2914 2 20.0822 4.63546 18.9004 6.78985C18.4089 7.6788 17.3631 8.10758 16.3905 7.81475C15.261 7.46963 13.7759 6.78985 11.883 5.49304L5.48258 11.8934C5.48258 11.8934 7.23955 13.9537 7.90888 16.3486C8.17033 17.2899 7.71017 18.2939 6.84214 18.754C5.79632 19.3083 4.25897 19.8835 2 20.3123V29.3586C2 29.3586 4.63546 29.5678 6.78985 30.7496C7.6788 31.2411 8.10758 32.2869 7.81475 33.2595C7.46963 34.389 6.78985 35.8741 5.49304 37.767L11.8934 44.1674C11.8934 44.1674 13.9537 42.4104 16.3486 41.7411C17.3003 41.4797 18.2939 41.9398 18.754 42.8079C19.3083 43.8537 19.873 45.391 20.3123 47.65H29.3586C29.3586 47.65 29.5678 45.0145 30.7496 42.8601C31.2411 41.9712 32.2869 41.5424 33.2595 41.8352C34.389 42.1804 35.8741 42.8601 37.767 44.157L44.1674 37.7566C44.1674 37.7566 42.4104 35.6963 41.7411 33.3014C41.4797 32.3497 41.9398 31.3561 42.8079 30.896Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4849,
    cy: 24.4849,
    r: 10.7769,
    stroke: "white",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.cd3de325a8606d88c26b624ffba46388.svg";
export { ForwardRef as ReactComponent };